export default "__VITE_ASSET__81fab391__"